var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.activationMode === "activate" ? "Activar" : "Inactivar",
        icon:
          _vm.activationMode === "activate"
            ? "mdi-account-check"
            : "mdi-account-remove"
      }
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c(
                "v-row",
                {
                  staticClass: "d-flex justify-center pa-4",
                  attrs: { "no-gutters": "" }
                },
                [
                  _c("v-col", { staticClass: "d-flex justify-center py-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "question my-2",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _vm._v(
                          " ¿" +
                            _vm._s(
                              _vm.activationMode === "activate"
                                ? "Activar"
                                : "Inactivar"
                            ) +
                            " el siguiente contacto? "
                        )
                      ]
                    )
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-center py-2",
                      attrs: { cols: "12" }
                    },
                    [
                      _c("v-avatar", { attrs: { color: "pink", size: "80" } }, [
                        !!_vm.contactToModify.lastName &&
                        !!_vm.contactToModify.name
                          ? _c(
                              "span",
                              {
                                staticClass: "white--text image-text",
                                staticStyle: { "text-align": "center" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contactToModify.lastName[0].toUpperCase() +
                                        _vm.contactToModify.name[0].toUpperCase()
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-center py-2",
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "contact",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.displayContactNames(
                                  _vm.contactToModify.lastName,
                                  _vm.contactToModify.name
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-row-reverse pt-3",
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "white--text",
                                  attrs: {
                                    block: "",
                                    loading: this.isLoading,
                                    color: "green"
                                  },
                                  on: { click: _vm.submitContact }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.activationMode === "activate"
                                        ? "Activar"
                                        : "Inactivar"
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "green",
                                    block: "",
                                    outlined: "",
                                    disabled: this.isLoading
                                  },
                                  on: {
                                    click: function() {
                                      return this$1.closeModal()
                                    }
                                  }
                                },
                                [_vm._v("Cancelar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }